import { ForgotPassword } from './forgotPassword/ForgotPassword'
import { ResetPassword } from './resetPassword/ResetPassword'
import { SignIn } from './signIn/SignIn'
import { SignUp } from './signUp/SignUp'

export const AuthPages = {
  ForgotPassword,
  ResetPassword,
  SignUp,
  SignIn
}
